import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CampaignConcept from "../pages/campaign-concept/page";
import Storefront from "../pages/storefront/page";
import Interactive from "../pages/interactive/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/campaign-concept",
    element: <CampaignConcept />,
  },
  {
    path: "/storefront",
    element: <Storefront />,
  },
  {
    path: "/interactive",
    element: <Interactive />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
